import { createSlice } from "@reduxjs/toolkit";
import {
  getSupportingDocumentsConfig,
  uploadSupportingDocuments,
} from "api/supportingDocuments";
import { fetchWorkflow } from "api/formDisplay";

const initialState = {
  supportingDocumentsConfig: {},
  userWorkflowInfo: {},
  userWorkflowInfoError: false,
  supportingDocumentsConfigLoading: false,
  supportingDocumentsConfigError: false,
  requestSupportingDocumentsData: [],
  supportingDocumentsUploadedSuccess: false,
  configLoading: false,
  updateRequestedArray: [],
  fetchingSubWorkflow: false,
};

const requestedSupportingDocs = createSlice({
  name: "requestedSupportingDocs",
  initialState,
  reducers: {
    setSupportingDocumentsConfig: (state, action) => {
      state.supportingDocumentsConfig = action.payload;
    },
    setUserWorkflowInfo: (state, action) => {
      state.userWorkflowInfo = action.payload;
    },
    setRequestSupportingDocumentsData: (state, action) => {
      state.requestSupportingDocumentsData = action.payload;
    },
    resetConfigState: (state, action) => {
      state.supportingDocumentsConfig = {};
      state.supportingDocumentsConfigLoading = false;
      state.supportingDocumentsConfigError = false;
      state.configLoading = false;
      state.supportingDocumentsUploadedSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSupportingDocumentsConfig.pending, (state, action) => {
        state.supportingDocumentsConfigLoading = true;
      })
      .addCase(getSupportingDocumentsConfig.fulfilled, (state, action) => {
        state.supportingDocumentsConfigLoading = false;
        state.supportingDocumentsConfig = action.payload;
      })
      .addCase(getSupportingDocumentsConfig.rejected, (state, action) => {
        state.supportingDocumentsConfigLoading = false;
        state.supportingDocumentsConfigError = true;
      });
    builder
      .addCase(uploadSupportingDocuments.pending, (state, action) => {
        state.configLoading = true;
      })
      .addCase(uploadSupportingDocuments.fulfilled, (state, action) => {
        state.configLoading = false;
        state.supportingDocumentsUploadedSuccess = true;
      })
      .addCase(uploadSupportingDocuments.rejected, (state, action) => {
        state.configLoading = false;
      });
    builder
      .addCase(fetchWorkflow.pending, (state, action) => {
        state.fetchingSubWorkflow = true;
      })
      .addCase(fetchWorkflow.fulfilled, (state, action) => {
        const updatedRequested = action.payload?.updateRequested;
        state.updateRequestedArray = updatedRequested;
      })
      .addCase(fetchWorkflow.rejected, (state, action) => {
        state.fetchingSubWorkflow = false;
      });
  },
});

export const {
  setSupportingDocumentsConfig,
  setUserWorkflowInfo,
  resetConfigState,
  setRequestSupportingDocumentsData,
} = requestedSupportingDocs.actions;

export default requestedSupportingDocs.reducer;
